import { ScreenReaderBasic } from "../../../../src/examples/utilities/ScreenReader";
import CodeHighlight from "../../../../src/common/CodeHighlight";
import * as React from 'react';
export default {
  ScreenReaderBasic,
  CodeHighlight,
  React
};